import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import countryOptions from '../../../data/countries';
import { useTranslation } from 'react-i18next';

const PersonalInfoStep = ({ formData, errors, onChange }) => {
  const { t } = useTranslation('auth');
  return (
    <div className="space-y-4 md:space-y-6">
      <Input
        label={t('registration.firstNameLabel')}
        type="text"
        placeholder={t('registration.firstNamePlaceholder')}
        value={formData?.firstName}
        onChange={(e) => onChange('firstName', e?.target?.value)}
        error={errors?.firstName}
        required
      />
      <Input
        label={t('registration.lastNameLabel')}
        type="text"
        placeholder={t('registration.lastNamePlaceholder')}
        value={formData?.lastName}
        onChange={(e) => onChange('lastName', e?.target?.value)}
        error={errors?.lastName}
        required
      />
      <Input
        label={t('registration.emailLabel')}
        type="email"
        placeholder={t('registration.emailPlaceholder')}
        value={formData?.email}
        onChange={(e) => onChange('email', e?.target?.value)}
        error={errors?.email}
        required
      />
      <Input
        label={t('registration.institutionLabel')}
        type="text"
        placeholder={t('registration.institutionPlaceholder')}
        value={formData?.institution}
        onChange={(e) => onChange('institution', e?.target?.value)}
        error={errors?.institution}
        required
      />
      <Select
        label={t('registration.countryLabel')}
        options={countryOptions}
        value={formData?.country}
        onChange={(value) => onChange('country', value)}
        error={errors?.country}
        placeholder={t('registration.countryPlaceholder')}
        searchable
        required
      />
    </div>
  );
};

export default PersonalInfoStep;
